module.exports = __webpack_public_path__ + "img/expressvpn-connected.d06b033c.png";